import { AdminRepo, AdminApi } from "common/helpers/admin-page-class"

import { CatalogsApi } from "common/api"
import { filterCatalogs, sortCatalogs } from "./utils"

const organizer = {
    filter: filterCatalogs,
    sort: sortCatalogs
}
const repo = new AdminRepo(organizer)

const http = {
    get: CatalogsApi.get,
    create: CatalogsApi.create,
    update: CatalogsApi.update,
    remove: CatalogsApi.remove
}
const api = new AdminApi(http, repo)

const methods = {
    get: api.get.bind(api),
    create: api.create.bind(api),
    update: api.update.bind(api),
    remove: api.remove.bind(api)
}

export { methods as CatalogsApi }
